import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Layout from "components/layout";
import {
  getUserInfo,
  isSidebarVisible,
  showSurvey,
  hasAccessToRoute,
  getUserRole,
} from "utils/common";

const Protected = ({ isLoggedIn, showSurveyHeader, children }) => {
  const { pathname } = useLocation();
  const userRole = getUserRole();

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  // Check if user has access to the current route
  if (!hasAccessToRoute(pathname, userRole)) {
    return <Navigate to="/members" replace />; // Redirect to first allowed route
  }

  return (
    <Layout
      visibleSidebar={isSidebarVisible(pathname)}
      role={getUserInfo()?.type}
      showSurvey={!showSurvey(pathname)}
      showSurveyHeader={showSurveyHeader}
    >
      {children}
    </Layout>
  );
};

export default Protected;
